export const PUB_KEY = 'PUBLISHER';
export const SCREEN_SHARING_VIDEO_TYPE = 'custom';

export const OT_EVENTS = {
  STREAM_CREATED: 'streamCreated',
  STREAM_DESTROYED: 'streamDestroyed',
  STREAM_PROPERTY_CHANGE: 'streamPropertyChanged',
  VIDEO_ELEMENT_CREATED: 'videoElementCreated',
  AUDIO_LEVEL_UPDATED: 'audioLevelUpdated',
  VIDEO_DISABLED_WARNING: 'videoDisableWarning',
  VIDEO_DISABLED_WARNING_LIFTED: 'videoDisableWarningLifted',
  SESSION_DISCONNECTED: 'sessionDisconnected',
};

export const SIGNAL = {
  VISIT_ENDED: 'signal:visit_ended',
  VISIT_DURATION: 'signal:visit_duration',
  VISIT_METADATA: 'signal:visit_metadata',
  PROVIDER_CONNECTED: 'signal:provider_connected',
  PENDING_INVITATIONS: 'signal:pending_invitations',
};

export const OT_ERROR_CODES = {
  MEDIA_ACCESS_DENIED: 'OT_USER_MEDIA_ACCESS_DENIED',
  HARDWARE_UNAVAILABLE: 'OT_HARDWARE_UNAVAILABLE',
  NO_DEVICES_FOUND: 'OT_NO_DEVICES_FOUND',
  NO_VALID_CONSTRAINTS: 'OT_NO_VALID_CONSTRAINTS',
  NOT_SUPPORTED: 'OT_NOT_SUPPORTED',

  SESSION_AUTH_ERROR: 'OT_AUTHENTICATION_ERROR',
  SESSION_CONNECT_FAILED: 'OT_CONNECT_FAILED',
  SESSION_CONNECT_LIMIT: 'OT_CONNECTION_LIMIT_EXCEEDED',
  SESSION_INVALID_ID: 'OT_INVALID_SESSION_ID',
  NOT_CONNECTED: 'OT_NOT_CONNECTED',
};



// WEBPACK FOOTER //
// ./src/redux/opentok/helpers/constants.js